import React, { Component, MouseEvent, FormEvent } from 'react';
import { SearchResponse, SearchRequest } from '../../rpc/admin/search_pb';
import Adapter from './adapter';

interface InfoProps {
    adapter: Adapter;
    response: SearchResponse;
    request: SearchRequest;
}

interface InfoState { }

class Info extends Component<InfoProps, InfoState> {

    onClear = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        this.props.adapter.removeAllFilters();
    }

    onSelectChange = (e: FormEvent<HTMLSelectElement>) => {
        e.preventDefault();
        this.props.adapter.setLimit(parseInt(e.currentTarget.value));
    }

    render() {
        if (!this.props.response) {
            return <></>;
        }

        let start = 0;
        if (this.props.response.getTotal()) {
            start = this.props.request!.getOffset() + 1;
        }

        let end = 0;
        if (this.props.response.getTotal()) {
            end = Math.min(this.props.request!.getOffset() + this.props.request!.getLimit(), this.props.response.getTotal());
        }

        let total: string;
        if (this.props.response.getTotal() < 10000) {
            total = this.props.response.getTotal().toString();
        } else {
            total = 'lots and lots';
        }

        let query: JSX.Element = <></>;
        if (this.props.request!.getQuery()) {
            query = <div className="search-info-query">for "{this.props.request!.getQuery()}"</div>;
        }

        let filters: JSX.Element = <></>;
        if (this.props.request!.getFiltersList() && this.props.request!.getFiltersList().length) {
            filters = <div className="search-info-filters">(
                {this.props.request!.getFiltersList().length} filter{this.props.request!.getFiltersList().length > 1 && 's'}
                &nbsp;<button className="button button-link" onClick={this.onClear}>clear</button>)</div>;
        }

        return (
            <div className="search-info">
                <div>Showing {start}-{end}<span className="search-info-total"> of {total}</span>{query}{filters}</div>

                <div className="field is-horizontal">
                    <div className="field-label is-small">
                        <label className="label">Show:</label>
                    </div>
                    <div className="field-body">
                        <div className="field is-narrow">
                        <div className="control">
                            <div className="select is-small">
                        <select value={this.props.request!.getLimit()} onChange={this.onSelectChange}>
                            <option key={'limit-field-25'} value={25}>25</option>
                            <option key={'limit-field-50'} value={50}>50</option>
                            <option key={'limit-field-100'} value={100}>100</option>
                        </select>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Info;